import { createGlobalStyle } from 'styled-components';

import dmSansLight from '../assets/fonts/DMSans-Light.ttf';
import dmSansRegular from '../assets/fonts/DMSans-Regular.ttf';
import dmSansBold from '../assets/fonts/DMSans-Bold.ttf';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px;
  }
  @font-face {
    font-family: 'DM Sans';
    src: url(${dmSansLight});
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'DM Sans';
    src: url(${dmSansRegular});
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'DM Sans';
    src: url(${dmSansBold});
    font-weight: 700;
    font-style: normal;
  }

  body {
    margin: 0;
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont,
      'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
      'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${({ theme }) => theme.text};
    height: 100vh;
  }
  // global component styles
  a {
    color: ${({ theme }) => theme.foreground};
    text-decoration: none;
  }
`;

export default GlobalStyle;
